/**
 * CUSTOMER ADDRESSES STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getCustomerAddresses,
    getCustomerAddress,
    createCustomerAddresses,
    updateCustomerAddresses,
    deleteCustomerAddresses,
} from "Core/companies/customers/config/api.customer_addresses";

const state = {
    page: {},
    form: {},
    customer_addresses: [],
    selectedCustomerAddress: {
        entity_addresses_id: null,
        company_id: "",
        entity_address_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        entity_address_details: [],
    },
    customer_addresses_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_customer_addresses: {
        prime: {
            name: "prime",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        address1: {
            name: "address1",
            rules: "trim|max_length[255]|required",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        address2: {
            name: "address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        zip_code: {
            name: "zip_code",
            rules: "trim|exact_length[12]|required",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        city: {
            name: "city",
            rules: "trim|max_length[100]|required",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        state: {
            name: "state",
            rules: "trim|max_length[65]|required",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        country_id: {
            name: "country_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        address_type: {
            name: "address_type",
            rules: "trim|max_length[36]|required",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        new_prime_entity_addresses_id: {
            name: "new_prime_entity_addresses_id",
            rules: "trim|required",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        location_label: {
            name: "location_label",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    customer_addresses: (state) => {
        return state.customer_addresses;
    },
};

// actions
const actions = {
    async fetchCustomerAddresses({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getCustomerAddresses({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageCustomerAddresses", response.data.page);
                }

                commit("setCustomerAddresses", response.data.entity_addresses);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchCustomerAddress({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getCustomerAddress(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedCustomerAddress", response.data.entity_address);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async saveCustomerAddress({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["entity_addresses_id"] === "undefined" || body["entity_addresses_id"] == null || body["entity_addresses_id"] == "") {
                delete body["entity_addresses_id"];
                response = await createCustomerAddresses({ body: body, headers: config.headers });
            } else {
                let entity_addresses_id = body["entity_addresses_id"];
                delete body["entity_addresses_id"];
                response = await updateCustomerAddresses({ body: body, headers: config.headers }, entity_addresses_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteCustomerAddress({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteCustomerAddresses(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageCustomerAddresses(state, page) {
        state.page = page;
    },
    setCustomerAddresses(state, entity_addresses) {
        state.customer_addresses = entity_addresses;
    },
    setSelectedCustomerAddress(state, entity_address) {
        state.selectedCustomerAddress = entity_address;
    },
    resetSelectedCustomerAddress(state) {
        for (const key in state.selectedCustomerAddress) {
            if (key in state.rules_customer_addresses) {
                state.selectedCustomerAddress[key] =
                    state.rules_customer_addresses[key].default_value == "null" ? null : state.rules_customer_addresses[key].default_value;
            }
        }
    },
    resetCustomerAddresses(state) {
        state.page = {};
        state.form = {};
        state.customer_addresses = [];
        state.selectedCustomerAddress = {
            entity_addresses_id: null,
            company_id: "",
            entity_address_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            entity_address_details: [],
        };
        state.customer_addresses_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
